import { Injectable } from '@angular/core';
import { EncryptionService } from './Encryption.service';

@Injectable({
  providedIn: 'root'
})
export class PersistenceService {

  constructor(private encryptionService:EncryptionService) { }

  set (key: string, data: any) {
    try {
      localStorage.setItem(key,this.encryptionService.encryptionAES(JSON.stringify(data)));
    } catch (error) {
      console.log(error);
    }
  }

  get (key: string) {
    try {
      let value = localStorage.getItem(key);
      let obj = this.encryptionService.decryptionAES(value);
      if (!obj || obj === '') return;
      return JSON.parse(obj);
    } catch (e) {
      return null;
    }
  }
}
